<template>
  <q-input
    v-model="localValue"
    :clearable="true"
    :align="column.align"
    :hide-underline="true"
    placeholder="All"
    @clear="applyFilter"
    @keydown.native.enter="applyFilter"
  ></q-input>
</template>
<script>
export default {
  name: 'TextFilter',
  data () {
    return {
      localValue: ''
    }
  },
  props: {
    column: {
      type: Object
    },
    resource: {
      type: String,
      default () {
        return this.$route.meta.resource
      }
    },
    value: {
      type: [String, Array, Object, Number],
      default: () => ''
    }
  },
  computed: {
    labelField () {
      if (this.column.relation && this.column.relation.namespace) {
        const titleColumn = this.$store.getters[`${this.column.relation.namespace}/titleColumn`]
        if (titleColumn) {
          return titleColumn.field
        }
      }
      return this.column.field
    }
  },
  methods: {
    applyFilter () {
      if (this.column.relation) {
        this.$emit('apply', {
          [this.labelField]: this.localValue
        })
      } else {
        this.$emit('apply', this.localValue)
      }
    },
    setValue (v) {
      if (typeof v === 'object' && !Array.isArray(v) && v) {
        if (this.labelField && this.column.relation && v[this.labelField]) {
          this.localValue = v[this.labelField] || ''
        }
      } else {
        this.localValue = v || ''
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        this.setValue(v)
      },
      immediate: true
    }
  }
}
</script>
